import { Skeleton } from "@material-ui/lab";
import { default as React, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { DeviceType } from "../../redux/devices";
import { UserNearbyStatus } from "../../redux/devicesStatuses";
import { userNearbyStatusCreator } from "../../redux/devicesStatuses/selectors";
import { residentsCreator } from "../../redux/residents/selectors";
import { IAppState } from "../../redux/types";
import { usersByIdCreator, usersReady } from "../../redux/users/selectors";
import { langByLocal } from "../../utils/Languages";
import { AvatarResidentUser, UnknowUser } from "../common/AvatarUser";
import { OverflowTip } from "../common/Common";
import { ModalTypes } from "../status/Callbacks";
import { findTimetoShow, MarkForBed, useMarkForBed } from "../status/utils";
const ResidentStatuses = ({
  residentId,
  callback,
}: {
  residentId: string;
  callback: (...args: any) => void;
}): JSX.Element => {
  const { t } = useTranslation("common");

  const onClose = useCallback(() => {
    callback(ModalTypes.BACK);
  }, [callback]);
  const { label } = useMarkForBed({ residentId });
  return (
    <div className="resident-status-holder">
      <div className="resident-status" style={{ display: "flex" }}>
        <div className="flex-column flex-center-align flex-column-16 full-width ">
          <p>{t("status:residentStatus")}</p>
          <div className="flex-column flex-center full-width ">
            <MarkForBed residentId={residentId} />
            <p className="text-size-14">{label}</p>
            <UserNearbyBedIfNeeded residentId={residentId} />
          </div>
          <button
            className="btn secondary  with-icon save-view"
            onClick={onClose}
          >
            <i className="icon-close" />
            {t("buttons.Close")}
          </button>
        </div>
      </div>
    </div>
  );
};

const UserNearbyBedIfNeeded = ({ residentId }: { residentId: string }) => {
  const ResidentSelection = useMemo(() => residentsCreator(), []);
  const resident = useSelector((state: IAppState) =>
    ResidentSelection(state, residentId)
  );
  const vitalsId = Object.keys(resident.devicesMinimized).find(
    (el) => resident.devicesMinimized[el].type === DeviceType.vitals
  );
  const userNearby = useMemo(() => userNearbyStatusCreator(), []);
  const userNearbyStatus = useSelector((state: IAppState) =>
    userNearby(state, vitalsId)
  );
  if (userNearbyStatus?.nearBed?.length > 0)
    return <UserNeabyBedWithTooltip userNearbyStatus={userNearbyStatus} />;
  return null;
};
const UserNeabyBedWithTooltip = ({
  userNearbyStatus,
}: {
  userNearbyStatus: UserNearbyStatus;
}): JSX.Element => {
  const { t } = useTranslation("status");
  const memoUsers = useMemo(() => usersByIdCreator(), []);
  const exist = userNearbyStatus?.nearBed?.filter((el) => el.id);
  const users = useSelector((state: IAppState) =>
    memoUsers(
      state,
      exist.map((el) => el.id)
    )
  );
  const usersLoaded = useSelector(usersReady);
  const { language } = useSelector((state: IAppState) => state.userProfile);
  const lang = langByLocal(language);
  return (
    <div className="flex-column flex-center flex-column-16 full-width ">
      <p className="text-size-14">{t("User nearby")}</p>

      {userNearbyStatus?.nearBed.map((el, index) => {
        const thisUser = users[index];
        return (
          <div
            className="flex-between one-user"
            key={el.id + el?.datetime + index}
          >
            <div className="flex-column">
              <div className="text-avatar flex-gap">
                {usersLoaded ? (
                  <>
                    {thisUser ? (
                      <AvatarResidentUser profile={thisUser} size="32" />
                    ) : (
                      <UnknowUser showName={true} />
                    )}
                  </>
                ) : (
                  <Skeleton variant="circle" width={32} height={32} />
                )}

                {usersLoaded && thisUser ? (
                  <OverflowTip
                    text={[thisUser?.firstName, thisUser?.lastName].join(" ")}
                    className="text-size-12"
                  />
                ) : (
                  <Skeleton variant="rect" width={80} height={14} />
                )}
              </div>
              {el?.alert && (
                <span
                  style={{ color: "#F5B66B", marginRight: "auto" }}
                  className="heebo-m text-size-10"
                >
                  {" "}
                  {t("continuous detection")}
                </span>
              )}
            </div>
            <span className="text-size-12 time-show">
              {findTimetoShow(el.datetime, lang)}
            </span>
          </div>
        );
      })}
    </div>
  );
};
export default React.memo(ResidentStatuses);
